import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "../styles/globals.css";
import "../styles/semana-cafe.css";
import "../styles/storefront.css";
import "../styles/memories.css";
import "../styles/footer.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
